/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component } from 'react'

import { Swipeable } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { ImageWithIconFallback } from '@skytech/ui/Image'
import ImageOffOutlineIcon from 'mdi-react/ImageOffOutlineIcon'
import { injectIntl } from 'react-intl'

import { useAppContext } from '@/App.context'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { numberFormat } from '@/util/formatters/numbers'

import { Translation } from '../i18n/Translation'

class Order2ModelPrice extends Component {
  // @ts-ignore
  constructor(props) {
    super(props)
    this.state = {}
  }

  cancel = () => {
    // @ts-ignore
    this.props.cancelOrder()
  }
  // @ts-ignore
  setModel = e => {
    // @ts-ignore
    const models = this.props.models
    const idx = e.target.value
    // @ts-ignore
    this.props.setSelectedModel(models[idx])
  }

  // @ts-ignore
  getImage = deviceName => {
    // @ts-ignore
    const model = this.props.selectedModel || this.props.models[0]
    const localImgUrl = './images/' + deviceName.replace(/ /g, '').replace('+', 'Plus') + '.png'

    return model.imgUrl ? model.imgUrl : localImgUrl
  }

  getDetails = () => {
    // @ts-ignore
    const { models, intl } = this.props
    const { formatMessage } = intl
    const deviceName = models[0].device

    return (
      <div>
        <div className="header">{deviceName}</div>

        <div className="picture">
          <ImageWithIconFallback
            src={this.getImage(deviceName)}
            alt={deviceName}
            fallbackIcon={<ImageOffOutlineIcon />}
          />
        </div>

        <div className="choose-model">
          <select className="models" onChange={this.setModel}>
            <option value="-1">{formatMessage({ id: 'Velg modell' })}</option>
            {this.getModels()}
          </select>

          {this.getPrice()}
          <Button variant="tertiary" onClick={this.cancel}>
            <Translation id="Avbryt" />
          </Button>
        </div>
      </div>
    )
  }

  getPrice = () => {
    const { confirm } = window

    // @ts-ignore
    const { selectedModel: model, settings, intl } = this.props
    const { formatMessage } = intl

    if (!model) return null

    const remainder =
      settings.covered_amount > model.price ? 0 : model.price - settings.covered_amount

    const hasStockCounter = () =>
      settings.dp_vendor_id === 5 || // Elkjop
      settings.dp_vendor_id === 2 || // Telenor
      settings.dp_vendor_id === 6 || // Mobit
      settings.dp_vendor_id === 9 || // Telia
      settings.customer_head_id === 1 || // Skytech
      settings.dp_vendor_id === 7 // Dustin

    // @ts-ignore
    const progress = downPaymentDuration => {
      const prompt =
        hasStockCounter() && (model.stock === 0 || model.stock === '0')
          ? confirm(formatMessage({ id: 'NB! Varen er ikke på lager!' }))
          : true
      if (prompt) {
        // @ts-ignore
        this.props.createOrder(model, remainder, downPaymentDuration)
      }
    }

    return (
      <div className="pricing">
        <p>
          <Translation id="Din arbeidsgiver dekker opp til" /> &nbsp;
          <br />
          <b>
            <FormattedNumberWithCurrency amount={settings.covered_amount || 0} />
          </b>
        </p>
        <p>
          <Translation id="Din pris" /> &nbsp;
          <br />
          <b>
            <FormattedNumberWithCurrency amount={remainder || 0} />
          </b>
        </p>

        {hasStockCounter() && (
          <p>
            <Translation id="På lager" /> &nbsp;
            <br />
            <b className={model.stock === 0 ? 'out-of-stock' : ''}>
              <Translation
                id="{amount} stk."
                values={{
                  // @ts-ignore
                  amount: typeof model.stock === Number ? numberFormat(model.stock) : model.stock,
                }}
              />
            </b>
            {model.stock > 0 && <Translation id="(Leveringstid 1-2 dager)" />}
          </p>
        )}

        <Button
          variant="primary"
          // @ts-ignore
          isVisible={Boolean(model)}
          onClick={progress.bind(this, remainder > 0 ? 1 : 0)}
        >
          {remainder > 0 ? (
            <Translation id="Trekk hele beløpet fra neste lønning" />
          ) : (
            <Translation id="Kjøp denne telefonen" />
          )}
        </Button>

        {settings.payment_interval > 0 && (
          <Button
            variant="primary"
            // todo: improve this logic when refactoring
            // @ts-ignore
            isVisible={!(remainder < settings.minimum_amount || remainder <= 0 || !model)}
            onClick={progress.bind(this, settings.payment_interval)}
          >
            <Translation
              id="Trekk {price} fra de neste {amount} lønningene"
              values={{
                price: (
                  <FormattedNumberWithCurrency amount={remainder / settings.payment_interval} />
                ),
                amount: (
                  <FormattedNumberWithCurrency
                    amount={settings.payment_interval}
                    showCurrency={false}
                  />
                ),
              }}
            />
          </Button>
        )}
      </div>
    )
  }

  getModels = () => {
    // @ts-ignore
    const { models, settings, intl } = this.props
    const { formatMessage } = intl

    let idx = -1
    // @ts-ignore
    return models.map(model => {
      let modelString = model.model.replace(' ', ' ') // remove non break spaces -_-
      let remainder =
        settings.covered_amount > model.price ? 0 : model.price - settings.covered_amount
      modelString = modelString.replace(model.device, '')
      idx++

      return (
        <option className="model" key={model.id} value={idx}>
          {modelString || formatMessage({ id: 'Standard' })} -{' '}
          <FormattedNumberWithCurrency amount={remainder} />
        </option>
      )
    })
  }

  render() {
    // @ts-ignore
    const { models } = this.props

    return (
      <Swipeable
        id="device"
        // @ts-ignore
        className={this.props.display ? 'is-visible' : 'is-hidden'}
        onSwipedLeft={this.cancel}
      >
        {/* eslint-disable-next-line eqeqeq */}
        {models != null ? this.getDetails() : null}
      </Swipeable>
    )
  }
}
// @ts-ignore
const Order2ModelPriceWrapper = props => {
  const { whiteLabel } = useAppContext()

  return <Order2ModelPrice whiteLabel={whiteLabel} {...props} />
}

export default injectIntl(Order2ModelPriceWrapper)
